
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 25 25"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_15708","data-name":"Rectangle 15708","width":"25","height":"25","fill":"none"}})])]),_c('g',{attrs:{"id":"Group_46512","data-name":"Group 46512","transform":"translate(-804 -697)"}},[_c('g',{attrs:{"id":"Group_46501","data-name":"Group 46501","transform":"translate(804 697)"}},[_c('rect',{attrs:{"id":"Rectangle_15707","data-name":"Rectangle 15707","width":"25","height":"25","fill":"none"}}),_c('g',{attrs:{"id":"Group_46491","data-name":"Group 46491"}},[_c('g',{attrs:{"id":"Group_46490","data-name":"Group 46490","clip-path":"url(#clip-path)","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"id":"Path_38730","data-name":"Path 38730","d":"M22.555 6.437V5.055a1.694 1.694 0 00-3.387 0v1.382m-.283 4.144h3.948a.839.839 0 00.848-.829V7.266a.839.839 0 00-.848-.829h-3.948a.838.838 0 00-.847.828h0v2.487a.839.839 0 00.847.83z","stroke":"#8d97a1"}}),_c('path',{attrs:{"id":"Path_38731","data-name":"Path 38731","d":"M21.733 14.211A10.468 10.468 0 0112.5 19.2a10.466 10.466 0 01-9.962-6.415h0a.813.813 0 010-.571A10.461 10.461 0 0112.5 5.8a10.448 10.448 0 012.507.227","stroke":"#8c96a1"}}),_c('circle',{attrs:{"id":"Ellipse_949","data-name":"Ellipse 949","cx":"3","cy":"3","r":"3","transform":"translate(9.613 9.5)","stroke":"#8c96a1"}})])])])])])
          )
        }
      }
    